const formula_path = 'products/formula/'

const list = ({ opt = {} }) => axios.get(formula_path, opt)
const create = ({ form, opt = {} }) => axios.post(formula_path, form, opt)
const edit = ({ pk, form, opt = {} }) =>
  axios.put(`${formula_path}${pk}/`, form, opt)
const show = ({ pk, opt = {} }) => axios.get(`${formula_path}${pk}/`, opt)
const remove = ({ pk }) => axios.delete(`${formula_path}${pk}/`)
const clone = ({ pk }) => axios.post(`${formula_path}${pk}/clone_formula/`)

const attributes_path = 'products/formulattributes/'
const attributes = {
  list: ({ opt = {} }) => axios.get(attributes_path, opt),
  create: ({ form, opt = {} }) => axios.post(attributes_path, form, opt),
  edit: ({ pk, form, opt = {} }) =>
    axios.put(`${attributes_path}${pk}/`, form, opt),
  show: ({ pk, opt = {} }) => axios.get(`${attributes_path}${pk}/`, opt),
  remove: ({ pk }) => axios.delete(`${attributes_path}${pk}/`)
}

export default { list, create, edit, show, remove, clone, attributes }
